import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { DriverProfile } from 'src/app/demo/models/common-data-types';
import { DriversService } from 'src/app/demo/service/drivers.service';
import { ProgressLoaderService } from 'src/app/demo/service/progress-loader.service';
import { ShowOutstandingDocumentsComponent } from '../../common/show-outstanding-documents/show-outstanding-documents.component';
import { Message, MessageService } from 'primeng/api';
import { ShowDocumentsComponent } from '../../common/show-documents/show-documents.component';
import { LanguageService } from 'src/app/demo/service/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { MessageModule } from 'primeng/message';
import { CustomToastrService } from 'src/app/demo/service/custom-toastr.service';

@Component({
    selector: 'app-driver-detail',
    standalone: true,
    imports: [
        CommonModule,
        DividerModule,
        CardModule,
        ButtonModule,
        MessagesModule,
        MessageModule,
        TooltipModule,
        FileUploadModule,
        CalendarModule,
        TranslateModule,
        InputTextModule,
        ShowOutstandingDocumentsComponent,
        ShowDocumentsComponent,
    ],
    templateUrl: './driver-detail.component.html',
    styleUrl: './driver-detail.component.scss',
    providers: [MessagesModule],
})
export class DriverDetailComponent implements OnInit {
    driver!: DriverProfile;
    driverId!: string;
    messages: Message[] = [];
    selectedLanguage: any = null;
    constructor(
        private progressLoader: ProgressLoaderService,
        private router: Router,
        private toastService: CustomToastrService,
        private languageService: LanguageService,
        private translate: TranslateService,
        private messageService: MessageService,
        private driverService: DriversService,
        private wiseToastr: CustomToastrService,
        private route: ActivatedRoute
    ) {
        this.extractDriverId();
    }

    ngOnInit(): void {
        this.fetchDriverProfile();
        this.initializeLocale();
    }

    extractDriverId() {
        this.route.paramMap.subscribe((params) => {
            this.driverId = params.get('id')!;
        });
    }

    goToDriversListing() {
        this.router.navigate(['/home/drivers']);
    }

    fetchDriverProfile() {
        this.progressLoader.show('Fetching driver profile');
        this.driverService.getDriverDetails(this.driverId).subscribe({
            next: (value) => {
                this.driver = value;
                this.progressLoader.hide();
            },
            error: (err) => {
                this.toastService.showError(
                    this.translate.instant(err.error.messageKey)
                );
            },
        });
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    languageChanged(event: DropdownChangeEvent) {
        this.setLanguage(event.value);
    }

    onDocumentUploaded(event: any) {
        this.progressLoader.show('Uploading Document ...');
        this.driverService.uploadDocument(this.driverId, event).subscribe({
            next: (value) => {
                this.driver = value;
                this.showSuccessToast('Document uploaded successfully');
                this.progressLoader.hide();
                if (this.driver.outstandingDocuments.length === 0) {
                    this.router.navigate(['/home/drivers']);
                }
            },
            error: (err) => {
                this.toastService.showError(this.translate.instant(err.error.messageKey))
                this.progressLoader.hide();
            },
        });
    }

    convertToTitleCase(input: string): string {
        return input
            .toLowerCase()
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    showSuccessToast(message: string) {
        this.wiseToastr.showSuccess(message);
    }

    showErrorToast(message: string) {
        this.wiseToastr.showError(message);
    }
}
